"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.yesNoPercentFilled = exports.yesNoPercentEmpty = exports.yesNoCountFilled = exports.yesNoCountEmpty = void 0;
const flattenDeep_1 = __importDefault(require("lodash-es/flattenDeep"));
const field_logic_1 = require("../field-type-registry/field-logic");
function yesNoEmptyValuesAggregator(aggregate) {
    return (0, field_logic_1.valuesAggregator)((recordValues) => {
        const empties = recordValues.filter((recordValue) => {
            // TODO: The Lookup field uses this aggregations without modifications. It is necessary to
            //  rewrite receiving aggregations through a function as receiving filtering functions (getComparisons).
            //  Move logic flatten to Lookup field logic
            return (0, flattenDeep_1.default)([recordValue, false]).every((value) => value === false);
        });
        return aggregate(empties.length, recordValues.length);
    });
}
exports.yesNoCountEmpty = yesNoEmptyValuesAggregator((empty) => empty);
exports.yesNoCountFilled = yesNoEmptyValuesAggregator((empty, total) => total - empty);
exports.yesNoPercentEmpty = yesNoEmptyValuesAggregator((empty, total) => Number(((empty / total) * 100).toFixed(2)));
exports.yesNoPercentFilled = yesNoEmptyValuesAggregator((empty, total) => Number((((total - empty) / total) * 100).toFixed(2)));
